import { SearchItem } from './search.item';
import { CommonEnums } from '../../common.enums';
import { ListUtil } from '../../utils/list.util';

export class FilterSearchObject {

    obj_Cd: string;
    objNm: string;
    selected: boolean;
    searchItems: Array<SearchItem>;

    constructor() {
        this.obj_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.objNm = CommonEnums.defaults.STRING_EMPTY;
        this.selected = false;
        this.searchItems = new Array<SearchItem>();
    }

    static parse( filterSearchObjectTmp: FilterSearchObject ): FilterSearchObject {
        let filterSearchObject: FilterSearchObject = new FilterSearchObject();
        filterSearchObject.copyFrom( filterSearchObjectTmp );

        return filterSearchObject;
    }

    copy(): FilterSearchObject {
        let filterSearchObjectTmp: FilterSearchObject = new FilterSearchObject();

        filterSearchObjectTmp.obj_Cd = this.obj_Cd;
        filterSearchObjectTmp.objNm = this.objNm;
        filterSearchObjectTmp.selected = this.selected;

        filterSearchObjectTmp.searchItems = new Array<SearchItem>();
        for( var i: number = 0; i < this.searchItems.length; i++ ) {
            let searchItem: SearchItem = this.searchItems[i] as SearchItem;
            filterSearchObjectTmp.searchItems.push( searchItem.copy() );
        }

        return filterSearchObjectTmp;
    }

    copyFrom( filterSearchObjectTmp: FilterSearchObject ): void {
        this.obj_Cd = filterSearchObjectTmp.obj_Cd;
        this.objNm = filterSearchObjectTmp.objNm;
        this.selected = filterSearchObjectTmp.selected;

        let searchItemsMap: Map<string, SearchItem> = new Map();

        for( let i: number = 0; i < this.searchItems.length; i++ ) {
            let searchItem: SearchItem = this.searchItems[i] as SearchItem;
            searchItemsMap.set( searchItem.objNm, searchItem );
        }

        ListUtil.getInstance().splice( this.searchItems );

        for( let i: number = 0; i < filterSearchObjectTmp.searchItems.length; i++ ) {
            let searchItemTmp: SearchItem = SearchItem.parse( filterSearchObjectTmp.searchItems[i] as SearchItem );

            let searchItem: SearchItem = searchItemsMap.get( searchItemTmp.objNm );
            if( searchItem ) {
                searchItem.copyFrom( searchItemTmp );
            } else {
                searchItem = searchItemTmp.copy();
            }

            this.searchItems.push( searchItem );
        }
    }

    deSelectAll(): void {
        this.selected = false;
        for( var i: number = 0; i < this.searchItems.length; i++ ) {
            let searchItem: SearchItem = this.searchItems[i] as SearchItem;
            searchItem.selected = false;
        }
    }
}